import React from 'react'
import { Text, Box } from 'grommet'
import styled from 'styled-components'
import { device } from '../../theme/device'

const Container = styled(Box)`
  min-height: 4rem;
`

const LabelBox = styled(Box)`
  padding: 0 2rem 0 0;

  @media ${device.medium} {
    padding: 0 0 0.5rem 0;
    flex-grow: 1;
    flex-shrink: 0;
  }
`

const teamNameInput = ({ children, label, labelWidth = '10rem' }) => {
  return (
    <Container direction="row">
      <LabelBox
        width={labelWidth}
        justify="center"
        // pad={size === "medium" ? { bottom: ".5rem" } : { right: "2rem" }}
        // flex={size === "medium" && "grow"}
      >
        <Text>{label}</Text>
      </LabelBox>
      <Box flex="grow">{children}</Box>
    </Container>
  )
}

export default teamNameInput
